import React from "react";
import classes from "./Contacts.module.scss";
import officeUS from "../../media/contacts/office-us.png";
import officeUA from "../../media/contacts/ua-office.png";
import { useTranslation } from "react-i18next";

const OurOffice = () => {
  const { t } = useTranslation();

  const contacts = [
    {emoji: '📧', title: t('contacts.mail'), value: ['support@go-te.co']},
    {emoji: '📞', title: t('contacts.phone'), value: ['+1 (585) 445-1323', '+38 (044) 333-92-74']},
  ]

    const locations = [
        {image: officeUS, title: t('contacts.locations.titleUs'), value: t('contacts.locations.valueUs')},
        {image: officeUA, title: t('contacts.locations.titleUa'), value: t('contacts.locations.valueUa')},
    ]

  return (
    <div className={classes["our-office"]}>
      <h2 className={classes.title}>{t('contacts.office')}</h2>

      <div className={classes["blocks-container"]}>
          {contacts.map((contact) => (<div key={contact.title} className={classes.block}>
              <span className={classes.emoji}>{contact.emoji}</span>
              <div className={classes.info}>
                  <h4>{contact.title}</h4>
                  {contact.value.map(val => <span key={val}>{val}</span>)}

              </div>
          </div>))}
          {locations.map((contact) => (<div key={contact.title} className={classes.block}>
              <img src={contact.image} alt={'Office location'}/>
              <div className={classes.info}>
                  <h4>{contact.title}</h4>
                  <span>{contact.value}</span>
              </div>
          </div>))}
      </div>
    </div>
  );
};

export default OurOffice;
